import { ChartType, } from '../../../../../types/savedCharts';
export const getTableChartConfig = () => ({
    type: ChartType.TABLE,
    // Hide explore name prefixes in column headers by default
    config: {
        showTableNames: false,
    },
});
//# sourceMappingURL=getTableChartConfig.js.map